import { render, staticRenderFns } from "./addPromotionBanner.vue?vue&type=template&id=3db7dc63&lang=pug"
import script from "./addPromotionBanner.vue?vue&type=script&lang=js"
export * from "./addPromotionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports